/*!--------------------------------------------------------
 * Copyright (C) Microsoft Corporation. All rights reserved.
 *--------------------------------------------------------*/
/*---------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 *--------------------------------------------------------*/
define("vs/platform/terminal/node/ptyHostMain.nls", {
	"vs/base/common/errorMessage": [
		"{0}: {1}",
		"A system error occurred ({0})",
		"An unknown error occurred. Please consult the log for more details.",
		"An unknown error occurred. Please consult the log for more details.",
		"{0} ({1} errors in total)",
		"An unknown error occurred. Please consult the log for more details."
	],
	"vs/base/node/processes": [
		"Can't execute a shell command on a UNC drive."
	],
	"vs/platform/terminal/node/ptyService": [
		"Session contents restored from {0} at {1}"
	],
	"vs/platform/terminal/node/terminalProcess": [
		"Starting directory (cwd) \"{0}\" is not a directory",
		"Starting directory (cwd) \"{0}\" does not exist",
		"Path to shell executable \"{0}\" is not a file or a symlink",
		"Path to shell executable \"{0}\" does not exist"
	]
});